import React from 'react'
import styled from '@emotion/styled'
import { BaseRadioInput } from '../ui/form/BaseRadioInput'
import { SimulationType } from '../../redux/reducers/simulation.reducer'
import { mq } from '../breakpoints'

export type SimulationTypeChoiceProps = {
  onChange: (type: SimulationType) => void
  selectedType: SimulationType
}

export const SimulationTypeChoice = ({
  selectedType,
  onChange,
}: SimulationTypeChoiceProps) => {
  return (
    <RadioFormContainer>
      <RadioContainer>
        <RadioButton>
          <RadioInput
            type='radio'
            id='ccam-code-type'
            name='simulationType'
            checked={selectedType === 'ccam_code'}
            onChange={() => onChange('ccam_code')}
          />
          <label htmlFor='ccam-code-type'>
            <OptionLabel>Vous disposez d&apos;un devis</OptionLabel>
          </label>
        </RadioButton>
        <OptionHint>
          de votre dentiste, chirurgien, anesthésiste, etc relatif à un acte
          technique médical
        </OptionHint>
      </RadioContainer>
      <RadioContainer>
        <RadioButton>
          <RadioInput
            type='radio'
            id='common-care-type'
            name='simulationType'
            checked={selectedType === 'common_care'}
            onChange={() => onChange('common_care')}
          />
          <label htmlFor='common-care-type'>
            <OptionLabel>
              Vous souhaitez évaluer votre niveau de remboursement sur des soins
              courants&nbsp;:
            </OptionLabel>
          </label>
        </RadioButton>
        <OptionHint>consultation, séance de kiné, etc</OptionHint>
      </RadioContainer>
    </RadioFormContainer>
  )
}

const RadioFormContainer = styled.div`
  padding: 0 20px;
  margin: 0 auto;
  max-width: 450px;

  ${mq.lg} {
    display: flex;
    max-width: inherit;
    align-items: flex-start;
  }
`

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  ${mq.lg} {
    flex: 1;
    align-items: center;
    justify-content: space-between;
    height: 120px;
  }
`

const RadioButton = styled.div`
  display: flex;

  ${mq.lg} {
    justify-content: center;
  }
`

const RadioInput = styled(BaseRadioInput)`
  opacity: 0.5;

  & + label {
    opacity: 0.5;
  }

  &:checked,
  &:checked + label {
    opacity: 1;
  }

  ${mq.lg} {
    opacity: 1;

    & + label {
      opacity: 1;
    }
  }
`

const OptionHint = styled.p`
  font-size: 0.85rem;
  font-style: italic;
  text-align: center;
  max-width: 320px;
  align-self: flex-start;
  margin-left: 20px;

  ${mq.lg} {
    align-self: center;
    margin-left: 0;
  }
`

const OptionLabel = styled.span`
  display: block;
  margin-left: 15px;
  font-size: 1.25rem;
`
